import {
  GET_QUESTIONS_DECISION_TREE_START,
  GET_QUESTIONS_DECISION_TREE_SUCCESS,
} from './types';
import { createAction, getActionList } from './action-utils';
import {
  RequestQuestionsType,
  ResponseQuestionsType,
} from 'ts/types/decision-tree.types';

const actions = {
  getQuestionsDecisionTree: ({
    productId,
    lines,
    language,
    optionSelected,
    question,
    displayName,
    retryAttempt,
  }: RequestQuestionsType & {
    displayName: string;
    language: string;
    optionSelected: string;
    question: string;
    retryAttempt: number;
  }) =>
    createAction(GET_QUESTIONS_DECISION_TREE_START, {
      productId,
      language,
      lines,
      optionSelected,
      question,
      displayName,
      retryAttempt,
    }),
  getQuestionsDecisionTreeSuccess: (
    answer: string,
    displayName: string,
    language: string,
    optionSelected: string,
    question: string,
    response: ResponseQuestionsType,
    questionText: string,
    match: string[],
  ) =>
    createAction(GET_QUESTIONS_DECISION_TREE_SUCCESS, {
      answer,
      displayName,
      language,
      optionSelected,
      question,
      response,
      match,
      questionText,
    }),
};

export default actions;

const actionList = getActionList(actions);

export type DecisionTreeActionType = typeof actionList[number];
